export default {
  jobs: [],
  jobDefinitions: [],
  loading: false,
  itemsLength: 0,
  jobPoolStatuses: [],
  focusedJobGroup: null,
  tempDeliverables: [],
}
